import { useState } from 'react';
import styles from './LeadTickets.module.scss';
import { Empty, Flex } from 'antd';
import { Avatar } from '../../../common';
import toast from 'react-hot-toast';
import { getErrorString } from '../../../utils';
import Loader from '../../lead-details-common/loader';
import Search from '../../../common/search/Search';
import { CheckFillIcon } from '../../../common/all-icons/custom-icons';

const DropDownRenderBody = ({
  loader,
  users,
  selectedData,
  onSuccessResolve,
  changeFunc = () => {},
  type = 'ticket',
}) => {
  const [query, setQuery] = useState('');
  const [assigneeLoader, setAssigneeLoader] = useState(null);
  const filteredUserList = users?.filter((user) => user?.name?.toLowerCase()?.includes(query?.toLowerCase()));

  const changeAssignee = async (userId, user) => {
    if (loader) return;
    const data =
      type === 'ticket'
        ? {
            ticket: {
              assignee_id: userId,
            },
          }
        : { assignee_id: userId };
    try {
      setAssigneeLoader(userId);
      const response = await changeFunc(selectedData?.id, data);
      if (response?.status) onSuccessResolve(response?.data);
    } catch (error) {
      toast.error(getErrorString(error));
    } finally {
      setAssigneeLoader(null);
    }
  };

  return (
    <Flex vertical gap={12} className={styles.dropdownContent}>
      <Search
        placeholder="Search Assignee"
        onChange={(e) => setQuery(e.target.value)}
        value={query}
        style={{ height: '36px', paddingLeft: '12px' }}
        fontClass="body-12-regular"
        iconStyles={{ top: '9px', left: 'unset', right: '9px' }}
      />
      {loader ? (
        <Loader styles={{ marginTop: '10px' }} loaderSize={25} />
      ) : filteredUserList?.length ? (
        <Flex gap={12} vertical className="scroll-y" style={{ '--box-height': '280px' }}>
          {filteredUserList?.map((user, index) => {
            const selectedUser = selectedData?.assignee?.id == user?.id;
            return (
              <Flex
                key={index}
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => !selectedUser && changeAssignee(user?.id, user)}
                justify="space-between"
                gap={12}
                align="center"
              >
                <Flex align="center" justify="space" gap={12}>
                  <Avatar size={36} src={user?.profile_picture} isSystem={true} name={user?.name} />
                  <Flex vertical gap={4}>
                    <div className="body-12-medium">{user?.name}</div>
                    <div style={{ color: 'var(--user-main-text)' }} className="body-10-regular">
                      {user?.email}
                    </div>
                  </Flex>
                </Flex>
                {selectedUser ? (
                  <div style={{ color: 'var(--ant-color-primary)' }}>
                    <CheckFillIcon />
                  </div>
                ) : (
                  assigneeLoader === user?.id && <Loader loaderSize={18} />
                )}
              </Flex>
            );
          })}
        </Flex>
      ) : (
        <Empty className="mt-2" />
      )}
    </Flex>
  );
};

export default DropDownRenderBody;
